import React, { useContext, useEffect, useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import PermissionsEditor from './editors/PermissionsEditor';
import GridRolesPage from './editors/GridRolesPage';
import ActionsEditor from './editors/ActionsEditor';
import { AppDataContext } from '../../../context/Context';
import i18n from '../../../i18';

export default function RolesPermissionsContainer() {
    const context = useContext(AppDataContext);
    const [roles, setRoles] = useState([]);
    useEffect(() => {
        context
            .getState()
            .server.roles.getAll()
            .then((res) => {
                setRoles(res.data);
            })
            .catch((err) => {
                console.error(err);
            });
    }, []);
    const [selectedRoleId, setSelectedRoleId] = useState(null);
    const [tabIndex, setTabIndex] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const handleChange = (roleId, tab) => {
        setSelectedRoleId(roleId);
        setTabIndex(tab);
    };
    const createFilterReqByRole = (roleId) => {
        return [
            [
                {
                    field: 'role.id',
                    op: '=',
                    value: roleId
                }
            ]
        ];
    };

    return (
        <Box>
            <Tabs
                value={tabIndex}
                onChange={handleTabChange}
                sx={{ mb: 3, ml: 3 }}
            >
                <Tab label={i18n.t('columns.roles')} />
                <Tab label={i18n.t('columns.crudPermissions')} />
                <Tab label={i18n.t('columns.actionPermissions')} />
            </Tabs>

            {tabIndex === 0 && (
                <GridRolesPage onRoleChange={handleChange} context={context} />
            )}

            {tabIndex === 1 && (
                <PermissionsEditor
                    filter={
                        selectedRoleId
                            ? createFilterReqByRole(selectedRoleId)
                            : []
                    }
                    filterItemId={selectedRoleId}
                    filterItems={roles}
                    filterBy="role.id"
                    context={context}
                />
            )}

            {tabIndex === 2 && (
                <ActionsEditor
                    filter={
                        selectedRoleId
                            ? createFilterReqByRole(selectedRoleId)
                            : []
                    }
                    filterItemId={selectedRoleId}
                    filterItems={roles}
                    filterBy="role.id"
                    context={context}
                />
            )}
        </Box>
    );
}
